'use strict';
(function initializeCampaignSettingState(root) {
  const CURRENT_KEY = 'dnd-next-level:campaign-setting-current';
  const ACCESS_KEY = 'dnd-next-level:campaign-setting-current-access';
  const LOCKS_KEY = 'dnd-next-level:campaign-setting-locks:v1';

  const parseObject = raw => {
    try {
      const value = JSON.parse(raw);
      return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
    } catch (_error) {
      return null;
    }
  };
  const emptyLocks = () => ({version: 1, fields: []});
  const editableDm = () => ({exportDmSecrets: true, editable: true});
  const isCanonical = value => Boolean(
    value?.format === 'dnd-next-level-campaign-setting-current'
    && value.version === 1
    && value.campaign && value.access && value.locks
    && typeof value.access.exportDmSecrets === 'boolean'
    && typeof value.access.editable === 'boolean'
    && Array.isArray(value.locks.fields)
  );
  const canonicalFromCampaign = (campaign, access = editableDm(), locks = emptyLocks()) => ({
    format: 'dnd-next-level-campaign-setting-current',
    version: 1,
    campaign,
    access,
    locks,
  });
  const legacyParts = storage => {
    const access = parseObject(storage?.getItem(ACCESS_KEY));
    const locks = parseObject(storage?.getItem(LOCKS_KEY));
    const validAccess = typeof access?.dmSecrets === 'boolean'
      && typeof access?.locked === 'boolean' && !(access.locked && access.dmSecrets);
    const editable = validAccess ? !access.locked : true;
    return {
      access: editable
        ? {exportDmSecrets: validAccess ? access.dmSecrets : true, editable: true}
        : {exportDmSecrets: false, editable: false},
      locks: editable && locks?.version === 1 && Array.isArray(locks.fields) ? locks : emptyLocks(),
    };
  };
  const migrateCurrent = storage => {
    const value = parseObject(storage?.getItem(CURRENT_KEY));
    if (isCanonical(value)) return value;
    if (!value) return null;
    const parts = legacyParts(storage);
    const migrated = canonicalFromCampaign(value, parts.access, parts.locks);
    storage?.setItem(CURRENT_KEY, JSON.stringify(migrated));
    return migrated;
  };

  root.dndNextLevel = root.dndNextLevel || {};
  root.dndNextLevel.campaignSettingState = Object.freeze({
    currentKey: () => CURRENT_KEY,
    accessKey: () => ACCESS_KEY,
    locksKey: () => LOCKS_KEY,
    parseObject,
    isCanonical,
    emptyLocks,
    editableDm,
    canonicalFromCampaign,
    legacyParts,
    migrateCurrent,
  });
})(window);
